import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=13f93867&scoped=true&"
import script from "./PersonalData.vue?vue&type=script&lang=ts&"
export * from "./PersonalData.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalData.vue?vue&type=style&index=0&id=13f93867&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f93867",
  null
  
)

export default component.exports